module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('table', {
    staticStyle: {
      "border-style": "hidden"
    }
  }, [_c('caption', [_c('b', [_vm._v("Table 3")]), _vm._v(" Company Practices Before and After Lean and Green")]), _vm._v(" "), _c('thead', [_c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Before Lean and Green")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("After Lean and Green")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Purchases")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Buying, storing, and managing more materials than really needed; paying higher bills for energy and water.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Eliminating some purchases by designing processes and products that save steps, time, materials, and square footage; reducing other purchases by reusing existing materials.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Disposal")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Paying freight and handling to dispose of materials that could have been avoided, reused, or recycled; obtaining and renewing time-consuming and expensive permits for disposing of hazardous materials.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Paying less for disposal because much less is wasted; earning revenues through recycling.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Transportation")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Paying more for transportation of incoming materials and hauling waste.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Using less transportation by processing and packaging and reducing the quantity of materials flowing into and out of each site.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Labor")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Excessive hiring to maintain wasteful procedures; watching absences and illness rise owing to exposure to unnecessary chemicals.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Employees reporting fewer headaches and other illnesses and accidents; morale increases through the pride of working for a Lean and Green organization.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Cleanup and Fines")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Cleaning up spills and paying penalties of millions of dollars; damaged reputations and even prison sentences."), _c('a', {
    attrs: {
      "href": "#/#ft1",
      "id": "fn1"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Incurring no costs for cleanup or fines; strengthening reputations by processing wastes properly.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Revenues")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Losing market share to competitors who use material and energy efficiencies to offer less expensive products or products that have a smaller impact on the planet.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Earning greater market share by introducing efficiencies that allow prices of products to be reduced; offering innovative products that reduce operational costs and meet customers’ increasing “green” standards.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bottom Line")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Higher expenses and lower revenues = LESS PROFIT")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border-style": "hidden"
    },
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lower expenses and higher revenues = MORE PROFIT")])])])]), _vm._v(" "), _c('p', [_c('span', [_c('a', {
    attrs: {
      "href": "#/#fn1",
      "id": "ft1"
    }
  }, [_vm._v("*")]), _vm._v("As occurred at one of the twenty organizations before it became Lean and Green.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17aedbf6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1t3.vue
// module id = 84
// module chunks = 0